/**
 * 解析高峰管控产品代码
 * ---------- 快递员上门、扫码寄件、港澳台 ----------
 * | 顺丰标快 | T4 | SE0001 |
 * | 顺丰特惠 | T6 | SE0004 |
 * | 顺丰即日（专享） | T103 | SE0093 |
 * | 顺丰即日 | T104 | SE0002 |
 * | 高铁极速达次晨 | T109 | SE0097 |
 * | 顺丰次晨 | T801 | SE0003 |
 * | 高铁极速达 | T108 | SE0096 |
 * | 同城特快 | T121 | SE000205 |
 * ---------- 寄大件 ----------
 * SE0100 SE0101 SE0141 保持不变
 * ---------- 医药寄 ----------
 * | 医药安心递 | SP321 | SE0001(使用顺丰标快代替) |
 * ---------- 生鲜寄 ----------
 * | 大闸蟹专递 | SP334 | SE0034|
 * | 生鲜速配 | SP330 | SE0027 |
 * | 同城急送 | KUAISUDA | SE0083 |
 */
export const productCodeMap = {
    T4: 'SE0001',
    T6: 'SE0004',
    T103: 'SE0093',
    T104: 'SE0002',
    T109: 'SE0097',
    T801: 'SE0003',
    T108: 'SE0096',
    T121: 'SE000205',
    SE0100: 'SE0100',
    SE0101: 'SE0101',
    SE0141: 'SE0141',
    SP321: 'SE0001',
    SP334: 'SE0034',
    SP330: 'SE0027',
    KUAISUDA: 'SE0083'
}



// WEBPACK FOOTER //
// ./src/pages/waybill/waybillDetail/config.js